import React from 'react'
import { NavDropdown, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { enStyle } from '../../style/enStyle'
import { faStyle } from '../../style/faStyle'
import Forms from './Forms'
import './style.scss'

const ForgetPassword = () => {
    const {t, i18n} = useTranslation();
    const changeLangToFa = () => { localStorage.setItem("lang", "fa"); i18n.changeLanguage("fa"); faStyle() }
    const changeLangToEn = () => {  localStorage.setItem("lang", "en");  i18n.changeLanguage("en");  enStyle() }
    const changeLangToAr = () => { localStorage.setItem("lang", "ar"); i18n.changeLanguage("ar"); faStyle() }

    return (
        <div className="login">
            <div className='loginLang'>
                <NavDropdown title={t("lang")} id="authlang">
                    <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                    <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                    <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                </NavDropdown>
            </div>
            <Row>
                <div className="col-lg-6 p-0">
                    <div className="login-image">
                        <img src="./assets/img/3.jpg" alt="login" className="login-bg" />
                        <div className="login-content ">
                            <h2 className='animate__animated animate__fadeInDown'> {t("login_content_title")} </h2>
                            <p className='animate__animated animate__fadeInDown'>
                                {t("login_content_info_1")}<br/>
                                {t("login_content_info_2")}<br />
                                {t("login_content_info_3")}
                            </p>
                        </div>
                    </div>
                </div>
                <Forms />
            </Row>
        </div>
    )
}

export default ForgetPassword
